// Form validation for New credential form
import { plaintextValidator, dropdownValidator } from '../fields';

const config = { mandatory: true, customError: `^ Required` };

export default {
  name: plaintextValidator(config),
  'frequency.interval': function(
    value,
    attributes,
    attributeName,
    options,
    constraints
  ) {
    if (attributes.frequency.unit === 'MINS') {
      return {
        presence: true,
        numericality: {
          greaterThanOrEqualTo: 5,
          message: '^Min interval is 5'
        }
      };
    }

    return {
      presence: true,
      numericality: {
        greaterThanOrEqualTo: 1,
        message: '^Min interval is 1'
      }
    };
  },
  // 'frequency.unit': plaintextValidator(config),
  outputType: plaintextValidator(config),

  outputValues: function(
    value,
    attributes,
    attributeName,
    options,
    constraints
  ) {
    if (attributes.outputType !== 'Enum') {
      return null;
    }

    return {
      presence: true,
      length: { minimum: 1, message: '^Configure at least 1 enum value' }
    };
  },
  rules: {
    dynamicArray: {
      makeId: {
        presence: {
          allowEmpty: false
        }
      },
      oid: function(value, attributes, attributeName, options, constraints) {
        if (attributes.isExpressionMonitor === false) {
          return {
            presence: {
              allowEmpty: false
            },
            format: {
              pattern: /^\.\d+(\.\d+)*$/,
              message: 'should start with dot notation and only accept numbers'
            }
          };
        }
      },
      expressionDetail: function(
        value,
        attributes,
        attributeName,
        options,
        constraints
      ) {
        if (attributes.isExpressionMonitor) {
          return {
            presence: {
              allowEmpty: false
            }
          };
        }
      }
    }
  }
};
